import theme from '../../themes/green';

const styles = {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    backgroundColor: 'white',
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
  },
  Notifications: {
    Containers: {
      DefaultStyle: {
        padding: '0 10px 60px 10px',
      },
    },
    MessageWrapper: {
      DefaultStyle: {
        color: 'white',
        padding: '0px 40px 0 0',
      },
    },
    Dismiss: {
      DefaultStyle: {
        width: '35px',
        height: '35px',
        borderRadius: 0,
        fontFamily: 'Roboto',
        fontSize: '35px',
        lineHeight: '35px',
        fontWeight: '400',
        top: 'inherit',
        bottom: 0,
        right: 0,
      },
      error: {
        color: '#ffffff',
        backgroundColor: theme.pallete.error,
      },
      success: {
        color: '#ffffff',
        backgroundColor: theme.pallete.color,
      },
    },
    NotificationItem: {
      // Override the notification item
      DefaultStyle: {
        // Applied to every notification, regardless of the notification level
        padding: '12px 12px 5px 12px',
      },
      error: {
        borderTop: 'none',
        backgroundColor: 'transparent',
        borderBottom: `2px solid ${theme.pallete.error}`,
        WebkitBoxShadow: 'none',
        MozBoxShadow: 'none',
        boxShadow: 'none',
      },
      success: {
        borderTop: 'none',
        backgroundColor: 'transparent',
        borderBottom: `2px solid ${theme.pallete.color}`,
        WebkitBoxShadow: 'none',
        MozBoxShadow: 'none',
        boxShadow: 'none',
      },
    },
  },
};

export default styles;



// WEBPACK FOOTER //
// ./src/containers/AppWrapper/styles.js